export default __webpack_public_path__ + "static/media/Zone-2-Master-Plan.5925a2f5.png";